import React, { useState } from "react";
import { Card, CardBody, CardHeader, Input, Button, Link } from "@heroui/react";
import { Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { authService } from "@/services/authService";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("Please enter your email address");

      return;
    }

    try {
      setIsSubmitting(true);
      setError("");

      // Call your AuthService to request password reset

      await authService.requestPasswordReset(email);

      setSuccessMessage(
        "Password reset instructions have been sent to your email",
      );
      setEmail("");
    } catch (err: any) {
      setError(
        err.response?.data?.message || "Failed to send password reset request",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-default-100">
      <div className="w-full max-w-md p-4">
        <Card className="w-full">
          <CardHeader className="flex justify-center pt-6 pb-0">
            <img alt="Logo" className="h-16" src="/logo.svg" />
          </CardHeader>
          <CardBody className="px-6 py-8">
            <h1 className="text-2xl font-bold text-center mb-6">
              Reset Your Password
            </h1>

            {successMessage ? (
              <div className="bg-success-50 text-success p-4 rounded mb-6 text-center">
                <p>{successMessage}</p>
                <div className="mt-4">
                  <Button
                    className="mt-4"
                    color="primary"
                    variant="light"
                    onPress={() => navigate("/login")}
                  >
                    Return to Login
                  </Button>
                </div>
              </div>
            ) : (
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <p className="text-sm text-default-500 mb-4">
                    Enter your email address and we'll send you instructions to
                    reset your password.
                  </p>

                  <Input
                    autoFocus
                    errorMessage={error}
                    isInvalid={!!error}
                    label="Email Address"
                    placeholder="Enter your email"
                    startContent={
                      <Mail className="text-default-400" size={18} />
                    }
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <Button
                  className="w-full"
                  color="primary"
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Send Reset Instructions
                </Button>

                <div className="text-center mt-4">
                  <Link className="text-sm" href="/login" underline="hover">
                    Back to Login
                  </Link>
                </div>
              </form>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
